export const LOGIN_USER = 'LOGIN_USER'
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS'
export const LOGIN_USER_FAILURE = 'LOGIN_USER_FAILURE'
export const LOGOUT_USER = 'LOGOUT_USER'

export const RECOVERY_PASSWORD = 'RECOVERY_PASSWORD'
export const RECOVERY_PASSWORD_SUCCESS = 'RECOVERY_PASSWORD_SUCCESS'
export const RECOVERY_PASSWORD_FAILURE = 'RECOVERY_PASSWORD_FAILURE'
export const RESTART_RECOVERY = 'RESTART_RECOVERY'

export const REFRESH_TOKEN = 'REFRESH_TOKEN'
export const REFRESH_TOKEN_SUCCESS = 'REFRESH_TOKEN_SUCCESS'
export const REFRESH_TOKEN_FAILURE = 'REFRESH_TOKEN_FAILURE'

export const USER_CHANGE_PASSWORD = 'USER_CHANGE_PASSWORD'
export const USER_CHANGE_PASSWORD_SUCCESS = 'USER_CHANGE_PASSWORD_SUCCESS'
export const USER_CHANGE_PASSWORD_FAILURE = 'USER_CHANGE_PASSWORD_FAILURE'

export const SET_USER_CLIENT_ROLE = 'SET_USER_CLIENT_ROLE'
export const SET_USER_CLIENT_ROLE_SUCCESS = 'SET_USER_CLIENT_ROLE_SUCCESS'
export const SET_USER_CLIENT_ROLE_FAILURE = 'SET_USER_CLIENT_ROLE_FAILURE'

export const USER_MODAL_NEWS = 'USER_MODAL_NEWS'

export const USER_FORCE_PASSWORD_CHANGE = 'USER_FORCE_PASSWORD_CHANGE'
export const USER_SHOW_NOTIFICATION_ANIMATION = 'USER_SHOW_NOTIFICATION_ANIMATION'
export const CLEAN_ERROR = 'CLEAN_ERROR'